<template>
    <v-container class="email-verification" fluid>
        <HkiaraceBannerFrame :label="$t('email_verify_init.title')">
            <v-row>
                <v-col>
                    {{showSuccess ? $t('email_verify.success_msg') : $t('email_verify.error_msg')}}
                </v-col>
            </v-row>
<!--            <v-row>-->
<!--                <v-col>-->
<!--                    <v-btn color="primary"-->
<!--                           @click="finish()">{{$t('finish')}}-->
<!--                    </v-btn>-->
<!--                </v-col>-->
<!--            </v-row>-->
        </HkiaraceBannerFrame>
    </v-container>
</template>

<script>
    import HkiaraceBannerFrame from "../../components/HkiaraceBannerFrame";

    export default {
        name: 'EmailVerification',
        components: {HkiaraceBannerFrame},
        data() {
            return {
                token: this.$route.params.token,
                showError: false,
                showSuccess: false,
            };
        },
        mounted() {
            this.$callAPI('hkiarace/email_verify/', {token: this.token}, function (response) {
                this.showSuccess = true;

                this.$router.replace({name: 'id-verify'})
            }, function (response) {
                this.showError = true;
            })
        },
        methods: {
            finish() {
                window.close();
            },
        },
    }
</script>


<style lang="less">
    .email-verification {
        .email-verification-msg {
            font-size: 1.5rem;
        }

        .email-verification-complete-btn {
            width: 100%;
            background-color: #3b3a53;
            border-color: #3b3a53;
            color: white;
            font-weight: bold;
        }
    }
</style>